import {
  ROUTE_ACCESS_REQUEST,
  ROUTE_ACCESS_GRANTED,
  ROUTE_ACCESS_DENIED,
  REDIRECT_TO_LOGIN,
  REDIRECT_COMPLETED,
  CLEAR_ROUTE_ERROR
} from './actions';

const initialState = {
  isChecking: false,
  hasAccess: false,
  currentRoute: null,
  accessReason: null,
  token: null,
  timeRemaining: null,
  error: null,
  isRedirecting: false,
  redirectTo: null,
  redirectFrom: null,
  needsValidation: false // Don't force validation on initial load
};

const routeValidationReducer = (state = initialState, action) => {
  switch (action.type) {
    case ROUTE_ACCESS_REQUEST:
      return {
        ...state,
        isChecking: true,
        currentRoute: action.payload.pathname,
        error: null,
        needsValidation: false
      };

    case ROUTE_ACCESS_GRANTED:
      return {
        ...state,
        isChecking: false,
        hasAccess: true,
        currentRoute: action.payload.pathname,
        accessReason: action.payload.reason,
        token: action.payload.token || null,
        timeRemaining: action.payload.timeRemaining || null,
        error: null
      };

    case ROUTE_ACCESS_DENIED:
      return {
        ...state,
        isChecking: false,
        hasAccess: false,
        currentRoute: action.payload.pathname,
        accessReason: action.payload.reason,
        error: action.payload.error,
        token: null,
        timeRemaining: null
      };

    case REDIRECT_TO_LOGIN:
      return {
        ...state,
        isRedirecting: true,
        redirectTo: '/login',
        redirectFrom: action.payload.pathname,
        hasAccess: false
      };

    case REDIRECT_COMPLETED:
      return {
        ...state,
        isRedirecting: false,
        redirectTo: action.payload.redirectedTo,
        redirectFrom: action.payload.from
      };

    case CLEAR_ROUTE_ERROR:
      return {
        ...state,
        error: null,
        isChecking: false
      };

    default:
      return state;
  }
};

export default routeValidationReducer;
